import React from 'react';
import { Clock } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function CountdownBar() {
  const {
    minutes,
    seconds,
    isExpired
  } = useCountdown();
  return <div className="fixed top-0 left-0 w-full bg-[#E63946] text-white z-50 py-3 px-4 shadow-lg" data-id="element-129">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 md:gap-4 text-sm md:text-base font-bold uppercase tracking-wider" data-id="element-130">
        <Clock className="w-5 h-5 animate-pulse" data-id="element-131" />
        <span data-id="element-132">🔥 Esta oferta termina pronto:</span>
        <span className="bg-white text-[#E63946] px-2 py-0.5 rounded font-mono text-lg min-w-[80px] text-center" data-id="element-133">
          {!isExpired ? `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}` : '¡Oferta expirada!'}
        </span>
      </div>
    </div>;
}